import Flatlist from 'flatlist-react';
import { useContext, useEffect, useState } from 'react';
import { FaExpand } from "react-icons/fa";
import { IoIosAdd } from 'react-icons/io';
import { IoClose, IoLeafOutline } from 'react-icons/io5';
import { LuMilk, LuVegan } from 'react-icons/lu';
import { RiSubtractFill } from "react-icons/ri";
import { TbMeatOff } from 'react-icons/tb';
import { Oval } from 'react-loader-spinner';
import { useLocation, useParams } from 'react-router-dom';
import BoxAlert from '../../components/boxAlert';
import Loader from '../../components/loader';
import ReturnButton from '../../components/returnButton';
import ClientDataContext from '../../contexts/clientContext';
import CompanyContext from '../../contexts/companyContext';
import '../../css/scrollbar.css';
import { useAppRouter } from '../../hooks/useAppRouter';
import useStorage from '../../hooks/useStorage';
import { formatValue } from '../../scripts/formatValue';
import axios from '../../services/axios';
import RenderComplements from './components/renderComplements';
import styles from './css/product.module.css';
import { canPlaceOrders } from '../../scripts/canPlaceOrders';

const no_image_vector = require('../../assets/marca-dagua-sofchef.png');




const stripHtmlTags = (value) => (typeof value === 'string' ? value.replace(/<[^>]*>/g, '') : value);

function Product() {
  const storage = useStorage();
  const navigate = useAppRouter();
  const appLocation = useLocation();
  const { productId } = useParams();
  const { companyData } = useContext(CompanyContext);
  const { clientData } = useContext(ClientDataContext);
  const [product, setProduct] = useState([]);
  const [complements, setComplements] = useState([]);
  const [complementsCount, setComplementsCount] = useState([]);
  const [observation, setObservation] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const [prodPrice, setProdPrice] = useState(null);
  const [price, setPrice] = useState({ show: null, parse: null });
  const [expandImage, setExpandImage] = useState(false);
  const [loading, setLoading] = useState(true);
  const [loadingButton, setLoadingButton] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const [warnAlert, setWarnAlert] = useState({ show: false, title: null, text: null });
  const [isEditing, setIsEditing] = useState(false);
  const [editCartIndex, setEditCartIndex] = useState(null);
  const [editBasePrice, setEditBasePrice] = useState(null);
  const [initializedComplements, setInitializedComplements] = useState(false);


  useEffect(() => {
    (async () => {
      try {
        // Verifica se veio da edição do carrinho
        const editData = appLocation.state;
      
        if (editData && editData.isEditing) {
          setIsEditing(true);
          setEditCartIndex(editData.cartIndex);
          setEditBasePrice(editData.basePrice);
          
          // Define quantidade atual
          setQuantity(editData.currentQuantity || 1);
          
          // Define observação se existir
          setObservation(editData.observation || null);
          
          // Salva os complementos selecionados em um estado temporário
          if (editData.selectedComplements && editData.selectedComplements.length > 0) {
            // Converte para o formato da tela de produto
            const formattedComplements = editData.selectedComplements.map(comp => ({
              id: comp.id,
              collectionId: comp.collectionId,
              complement: comp.complement || comp.name, // Usa o campo correto
              price: comp.price,
              basePrice: comp.price,
              quantity: comp.quantity || comp.count,
              type: comp.type
            }));

            setComplementsCount(formattedComplements);
          }

        } else {
          setInitializedComplements(true);
        }

        if (productId) {
          await getProduct(productId);

        } else {
          navigate(-1);
        }

      } catch (error) {
        setErrorMessage(true);

      } finally {
        setLoading(false);
      }
    })();
  }, [appLocation.state]);



  useEffect(() => {
    if (complements.length > 0 && complementsCount.length > 0 && !initializedComplements) {

      complementsCount.forEach(selectedComp => {
        // Encontra a coleção do complemento
        const collectionIndex = complements.findIndex(col => 
          col.id === selectedComp.collectionId
        );
        
        if (collectionIndex !== -1) {
          // Encontra o índice do complemento dentro da coleção
          const complementIndex = complements[collectionIndex].complements.findIndex(
            comp => comp.id === selectedComp.id
          );
          
          if (complementIndex !== -1) {
            // Para cada unidade do complemento selecionado, simula a adição
            for (let i = 0; i < selectedComp.quantity; i++) {
              let array = [...complements];
              let comp = array[collectionIndex].complements[complementIndex];
              comp.count += 1;

              setComplements(array);
            }
          }
        }
      });
      
      setInitializedComplements(true);
      
      // Calcula o preço inicial se estiver em modo edição
      if (isEditing && editBasePrice) {
        let totalPrice = editBasePrice * quantity;
        
        complementsCount.forEach(comp => {
          totalPrice += comp.price * comp.quantity * quantity;
        });
        
        setPrice(totalPrice);
        setProdPrice(editBasePrice);
      }
    }
  }, [complements, complementsCount, isEditing, editBasePrice, quantity, initializedComplements]);


  // GET PRODUCT DATA FUNCTION =============>
  const getProduct = async (id) => {

    try {
      const response = await axios.get(`/smartmenu/catalog/product/${id}`, {
        params: {
          companyId: companyData.id
        },
      });

      if (!response.data) {
        setErrorMessage(true);
        return;
      }
        
      handleFormatProdData(response.data)

    } catch (error) {
      console.error('ERROR - GET PRODUCT DATA:', error);
      throw error;
    }
  };


  const handleFormatProdData = async (prodData) => {
    
    let objectProd = {...prodData};
    objectProd.prodPrice = formatValue(objectProd.price);
    objectProd.prodPromotionPrice = formatValue(objectProd.promotion_price);
    objectProd.complements = objectProd.complements ? objectProd.complements.split(',') : null;

    setProduct(objectProd);

    if (companyData.restriction && objectProd?.restricted && clientData && !clientData.older) {
      setWarnAlert({ show: true, title: 'Alerta', text: 'Produto não disponível:\n\nMotivo: Usuário menor de idade!' });
      
      navigate(-1);

    } else {

      let currentPrice;

      // SEMPRE busca o preço do servidor, mesmo no modo edição
      if (objectProd.promotion && objectProd.promotion_date >= new Date().toISOString().slice(0, 10)) {
        currentPrice = Number(objectProd.promotion_price);
        setProdPrice(currentPrice);

      } else {
        if(objectProd.type == 'combo'){
          currentPrice = Number(objectProd.fixed_products_price ?? 0);
          setProdPrice(currentPrice);
          
        } else {
          currentPrice = Number(objectProd.price);
          setProdPrice(currentPrice);
        }
      }

      // Se estiver em modo edição, mantém o preço base original
      // mas o cálculo final será feito com os complementos selecionados
      if (isEditing) {
        // O preço inicial será recalculado no useEffect acima
        setPrice(currentPrice);
      } else {
        setPrice(currentPrice);
      }

      if (objectProd.use_complements) {
        await getProductComplements(objectProd.id);

      } else {
        // Se não tiver complementos, marca como inicializado
        setInitializedComplements(true);
      }
    }
  
  } 

  // GET PRODUCT COMPLEMENTS DATA ===============>
  const getProductComplements = async (id) => {
    try {
      const response = await axios.get(`/smartmenu/catalog/product/${id}/complements`, {
        params: {
          companyId: companyData.id
        },
      });

      if (response.status == 200) {
        const sortedComplements = response.data.sort((a, b) => a.position - b.position);
        
        // Inicializa o contador de cada complemento como 0
        const initializedComplements = sortedComplements.map(collection => ({
          ...collection,
          complements: collection.complements.map(comp => ({
            ...comp,
            count: 0 // Inicializa todos como não selecionados
          }))
        }));
        
        setComplements(initializedComplements);

      }

    } catch (error) {
      console.error('ERROR - GET PRODUCTS COMPLEMENTS:', error);
      throw error;
    }
  };


  // CHANGE COMPLEMENTS AMOUNT FUNCTION ===========================>
  const changeComplementsAmount = (action, colId, compId, isCheckbox) => {
    let colIndex = complements.findIndex((comp) => comp.id === colId);
    let compIndex = complements[colIndex].complements.findIndex((comp) => comp.id == compId);

    let array = [...complements];

    let collection = array[colIndex];

    let comp = array[colIndex].complements[compIndex];

    switch (action) {
      case 'add':

        // REALIZA UMA BUSCA PELA QUANTIDADE DE COMPLEMENTOS SELECIONADOS DENTRO DA COLEÇÃO
        // A FIM DE BARRAR A SELEÇÃO CASO A QUANTIDADE MAXIMA FOR EXCEDIDA

        // Preço do item trocado (coleção selectOne), descontado do total mais abaixo junto com o
        // acréscimo do novo item — nesse arquivo o preço é sempre recalculado a partir do valor
        // atual de `price` num único `setPrice`, então a dedução precisa entrar nessa mesma conta.
        let priceAdjustment = 0;

        if (collection.max) {
          const objs = complementsCount.filter((item) => String(item.collectionId) === String(collection.id));

          const selectedQuantity = objs.reduce((total, item) => total + parseInt(item.quantity), 0);

          if (selectedQuantity == parseInt(collection.max)) {
            // Coleção de seleção única (max=1, ex.: checkbox "escolha 1"): em vez de bloquear a
            // seleção de um item diferente, troca automaticamente a seleção anterior pela nova —
            // evita exigir que o usuário desmarque manualmente antes de marcar outro item.
            const previousComp = parseInt(collection.max) === 1
              ? collection.complements.find((c) => c.count > 0 && c.id !== compId)
              : null;

            if (!previousComp) {
              return;
            }

            previousComp.count = 0;
            priceAdjustment = previousComp.price * quantity;

            setComplementsCount((prev) => prev.filter((item) => item.id !== previousComp.id));
          }
        }



        // CONTROLE DE SELEÇÃO UNITÁRIA PARA O COMPLEMENTO
        if (isCheckbox) {

          // CASO COMPLEMENTO JÁ TENHA SIDO SELECIONADOO, ELE ENTENDE QUE AGORA O MESMO DEVE SER REMOVIDO
          if (comp.count == 1) {
            let countArray = [...complementsCount];
            const compIndex = countArray.findIndex((comp) => comp.id === compId);

            countArray.splice(compIndex, 1);
            setComplementsCount(countArray);

            comp.count = 0;

            setComplements(array);

            const value = price - (comp.price * quantity);

            setPrice(value);

            return;
          }
        }
        
        
        // const pValue = price - comp.price * comp.count * quantity + comp.price * (comp.count + 1) * quantity;
        const pValue = price - priceAdjustment + (comp.price * quantity);
        
        setPrice(pValue);
        
        comp.count += 1;

        setComplementsCount((prev) => {
          let existComplement = false;

          if (prev.length > 0) {
            existComplement = prev.find((item) => item.id === compId);
          }

          if (existComplement) {
            return prev.map((comp) => {
              if (comp.id === compId) {
                return { ...comp, quantity: comp.quantity + 1 };
              }

              return comp;
            });

          } else {
            return [
              ...prev,
              {
                // CONFIGURA OS DADOS A SEREM INSERIDOS NO REGISTRO DO COMPLEMENTO SELECIONADO
                id: comp.id,
                collectionId: colId,
                complement: comp.name,
                price: comp.price,
                basePrice: comp.price,
                quantity: 1,
                type: comp.type
              },
            ];
          }
        });

        break;

      case 'minus':
        if (comp.count > 0) {
          comp.count -= 1;

          const pValue = price - comp.price * quantity;

          setPrice(pValue);

        }

        setComplementsCount((prev) => {

          if (comp.count == 0) {

            const removeEmptyComplement = prev.filter((item) => {
              return comp.count !== 0 || item.id !== compId;
            });

            return removeEmptyComplement;

          } else {
            return prev.map((complement) => {

              if (complement.id === compId) {
                return { ...complement, quantity: complement.quantity - 1 };
              }

              return complement;

            });
          }

          return prev;
        });

        break;

      default:
        break;
    }

    setComplements(array);
  };


  // FUNÇÃO DE ANÁLISE DA SELEÇÃO DOS COMPLEMENTOS DO PRODUTO
  const checkProductInstances = async () => {
    try {
      for (const collection of complements) {
        const soma = collection.complements.reduce((total, item) => total + item.count, 0);

        if (collection.mandatory && soma < collection.min) {
          setWarnAlert({ show: true, title: 'Alerta', text: `A coleção "${collection.name}" precisa ter pelo menos "${collection.min}" de seus complementos selecionados!` });
          throw new Error('stoped');
        }

        if (soma > collection.max) {
          setWarnAlert({ show: true, title: 'Alerta', text: `A coleção "${collection.name}" não pode ter mais que "${collection.max}" de seus complementos selecionados!` });
          throw new Error('stoped');
        }

      }

      await checkCartData();

    } catch (stoped) {
      return;
    }
  }


  // Checka se existe um pedido no local storage
  const checkCartData = async () => {
    try {
      let cart = storage.get('CART');

      if (!cart) {
        cart = {
          companyId: companyData.id,
          status: true,
          datetime: new Date().toISOString().slice(0, 10) + ' ' + new Date().toLocaleTimeString(),
          products: [],
          cart_price: 0,
        };
      }

      await saveProduct(cart);

    } catch (error) {
      console.error('ERROR - SAVE NEW CART:', error);
      setWarnAlert({ show: true, title: 'Erro', text: 'Não foi possível adicionar o produto ao carrinho! Tente novamente em instantes.' });
    }
  };



  // SAVE CART PRODUCT FUNCTION ==========================>
  const saveProduct = async (cart_data) => {
    try {
      let cart = cart_data;

      const productData = {
        amount: quantity,
        id: product.id,
        index: cart.products.length + 1,
        name: product.name,
        complements: complementsCount,
        base_price: prodPrice,
        total_price: price,
        restricted: product.restricted,
        image: product.image || null,
        observation: observation,
        type: product.type
      };

      if (isEditing) {
        // Substitui o produto no índice específico
        cart.products[editCartIndex] = productData;

        // Recalcula o preço total do carrinho
        cart.cart_price = cart.products.reduce((total, prod) => total + prod.total_price, 0);
        
      } else {
        cart.products.push(productData);
        cart.cart_price += price;
      }

      // ARMAZENA OS DADOS
      storage.save('CART', cart);

      navigate(-1);

    } catch (error) {
      console.error('ERROR - SAVE PRODUCT IN CART: ', error);
    }
  };

  const changeProductQuantity = (action) => {
    setQuantity((prevQuantity) => {
      let qtd = prevQuantity;
      switch (action) {
        case 'plus':
          qtd += 1;
          break;
        case 'minus':
          if (quantity > 1) {
            qtd -= 1;
          } else {
            qtd = 1;
          }
          break;
        default:
          break;
      }
      return qtd;
    });
  };



  useEffect(() => {
    let value = 0;

    if (complementsCount.length > 0) {
      value = complementsCount.reduce((value, complement) => {
        return value + complement.price * complement.quantity * quantity;
      }, 0);
    }

    value += prodPrice * quantity;

    setPrice(value);
  }, [quantity]);






  // <======================================== SCREEN ========================================>
  return (
    <div>
      {loading ? (
        <Loader />
      ) : (
        <div>

          <div className={styles.headerProduct} style={{ backgroundColor: companyData.background_color }}>
            <ReturnButton background={companyData.text_color} color={companyData.background_color} />
            <p className={styles.titleHeader} style={{ color: companyData.text_color }}>{isEditing ? 'Editar produto' : 'Adicionar produto'}</p>
          </div>


          <div className={styles.container}>

            <div className={styles.topProductArea}>
              {(product.promotion && product.promotion_date >= new Date().toISOString().slice(0, 10)) ? (
                <p className={styles.promotionAlert} style={{ backgroundColor: companyData.background_color, color: companyData.text_color }}>Em promoção!</p>
              ) : null}

              <div className={styles.imageTitleArea} >

                <div className={styles.productImage} style={{ backgroundColor: '#fff', backgroundImage: `url(${product.image || no_image_vector})`, backgroundPosition: 'center', backgroundSize: 'cover', backgroundRepeat: 'no-repeat' }} >
                  <button className={styles.btnExpandImage} style={{ backgroundColor: companyData.background_color }} onClick={() => setExpandImage(true)}>
                    <FaExpand size={20} color={companyData.text_color} />
                  </button>
                </div>

                <div className={styles.productInformations}>

                  <h1 className={styles.titleProduct}>{product.name}</h1>

                  {product.type == 'combo' ? (
                    <p className={styles.showPrice}>Á partir de {formatValue(product.price)}</p>

                  ) : (
                    <>
                      {product.promotion && product.promotion_date >= new Date().toISOString().slice(0, 10) ? (
                        <p className={styles.showPrice}>
                          <p style={{ color: 'red', textDecoration: 'line-through', marginLeft: 5, marginRight: 5 }}>{product.prodPrice}</p>
                          por
                          <p style={{ color: 'green', marginLeft: 5 }}>{product.prodPromotionPrice}</p>
                        </p>
                      ) : (
                        <p className={styles.showPrice}>{product.prodPrice}</p>
                      )}
                    </>
                  )}

                  {product.description ? (
                    <p className={styles.descriptionProduct}>
                      <b>Descrição:</b> {product.description}
                    </p>
                  ) : null}

                </div>
              </div>


              <div className={styles.amostreProductTypes}>
                <div className={styles.typeList}>
                  {product.organic && (
                    <div className={styles.typeArea} style={{ backgroundColor: companyData.background_color }}>
                      <IoLeafOutline size={20} color={companyData.text_color} />
                      <p style={{ marginLeft: 10, color: companyData.text_color }}>Orgânico</p>
                    </div>
                  )}
                  {product.vegetarian && (
                    <div className={styles.typeArea} style={{ backgroundColor: companyData.background_color }}>
                      <TbMeatOff size={20} color={companyData.text_color} />
                      <p style={{ marginLeft: 10, color: companyData.text_color }}>Vegetariano</p>
                    </div>
                  )}
                  {product.vegan && (
                    <div className={styles.typeArea} style={{ backgroundColor: companyData.background_color }}>
                      <LuVegan size={20} color={companyData.text_color} />
                      <p style={{ marginLeft: 10, color: companyData.text_color }}>Vegano</p>
                    </div>
                  )}
                  {product.contain_lactose && (
                    <div className={styles.typeArea} style={{ backgroundColor: companyData.background_color, minWidth: 130 }}>
                      <LuMilk size={20} color={companyData.text_color} />
                      <p style={{ marginLeft: 10, color: companyData.text_color }}>Tem lactose</p>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {canPlaceOrders(companyData) ? (

              <>
                <div style={{ marginBottom: 30 }}>
                  {complements.length > 0 && (
                    <Flatlist
                      list={[...complements].sort((a, b) => (b.use_products ? 1 : -1) - (a.use_products ? 1 : -1))}
                      renderItem={(item, index) => 
                        <RenderComplements 
                          key={item.id || index} 
                          collection={item} 
                          index={index} 
                          changeComplementsAmount={changeComplementsAmount} 
                          companyData={companyData} 
                          complementsCount={complementsCount} 
                        />
                      }
                      renderWhenEmpty={() => {
                        <div>
                          <p>Nada a apresentar</p>
                        </div>;
                      }}
                    />
                  )}
                </div>

                <div className={styles.observationsArea}>
                  <p className={styles.labelInputObservation}>Observações</p>
                  <textarea
                    id={styles.observationInput}
                    maxLength={255}
                    style={{ resize: 'none', borderColor: companyData.background_color }}
                    placeholder="Deseja alterar algo no pedido?"
                    value={observation}
                    onChange={({ target: { value } }) => setObservation(stripHtmlTags(value))}
                  />
                </div>


                <div className={styles.bottomArea} style={{ backgroundColor: companyData.background_color }}>
                  <div className={styles.groupBottomItems}>
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                      <button className={styles.boxQuantity} id="minus-quantity-square" style={{ backgroundColor: companyData.text_color }} onClick={() => changeProductQuantity('minus')}>
                        <RiSubtractFill size={20} color={companyData.background_color} />
                      </button>

                      <div className={styles.boxQuantity} style={{ backgroundColor: companyData.text_color }}>
                        <p id="quantity-value" style={{ color: companyData.background_color }}>
                          {quantity}
                        </p>
                      </div>

                      <button className={styles.boxQuantity} id="add-quantity-square" style={{ backgroundColor: companyData.text_color }} onClick={() => changeProductQuantity('plus')}>
                        <IoIosAdd size={20} color={companyData.background_color} />
                      </button>
                    </div>

                    <button className={styles.addButton} style={{ backgroundColor: price > 0 ? companyData.text_color : 'grey' }} onClick={() => checkProductInstances()}>
                      {loadingButton ? (
                        <Oval visible={true} height="45" width="45" color="#fff" />

                      ) : (
                        <>
                          <span className={styles.addBtnText} style={{ color: companyData.background_color, marginRight: 20 }}>
                            Adicionar
                          </span>

                          {price && price > 0 ? (
                            <span className={styles.addBtnText} style={{ color: companyData.background_color }}>
                              {formatValue(price)}
                            </span>

                          ) : null}
                        </>
                      )}
                    </button>
                  </div>
                </div>

              </>

            ) : null}

          </div>
        </div>
      )}

      {expandImage && (
        <div className={styles.imageModalOverlay} onClick={() => setExpandImage(false)}>
          <button className={styles.imageModalClose} onClick={() => setExpandImage(false)}>
            <IoClose size={26} color="#fff" />
          </button>

          <img
            className={styles.imageModalPicture}
            src={product.image || no_image_vector}
            alt={product.name}
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}

      <BoxAlert
        show={warnAlert.show}
        title={warnAlert.title}
        text={warnAlert.text}
        onClose={() => setWarnAlert({ show: false, title: null, text: null })}
      />

    </div>
  );
}

export default Product;
